const getters = {
    smProductTypes: state => state.sm_product_types,
    smProductType: state => state.sm_product_type,
    smProductTypeFilters: state => state.sm_product_type_filters,
}

export default getters;
